export const imgs = {
  banner:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1621787852/tinyblob/others/banner1_usgefd.webp",
  blue_circle:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1621787850/tinyblob/others/blue-circle_qkhed5.webp",
  consult:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1621842700/tinyblob/others/consult_ooqpcf.webp",
  bespoke:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1621842700/tinyblob/others/bespoke_jlsqx3.webp",
  integration:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1621842858/tinyblob/others/icons8-gears-64_wkg9tw.webp",
  logo: "https://res.cloudinary.com/yashwork2110/image/upload/v1621787849/tinyblob/others/logo-removebg_xflpad.webp",
  pipelines:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1623254490/tinyblob/others/ci-cd-devops-cycle-768x356_am6kly.png",
  security:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1623417823/tinyblob/others/WhatsApp_Image_2021-06-11_at_15.37.25_1_tmgdh5.webp",
  cloud:
    "https://res.cloudinary.com/yashwork2110/image/upload/v1623417556/tinyblob/others/WhatsApp_Image_2021-06-11_at_15.48.39_h8pmx6.webp",
};
